<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.ID }}</td>
                                <td>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                                <td class="text-right">{{ item.ValueMin | currency('', 3) }}</td>
                                <td class="text-right">{{ item.ValueMax | currency('', 3) }}</td>
                                <td class="text-right">{{ item.Amount | currency }}</td>
                                <td>
                                    {{ item.ModifiedDate | display_date}}
                                </td>
                                <td class="text-center">         
                                    <v-icon medium class="mr-2" @click="openItem(item.ID)" v-if="hasEditPermission">edit</v-icon>
                                    <v-icon medium @click="deleteItem(item.ID)" v-if="hasEditPermission">delete</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogItem" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="title">Chi tiết phí khối</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md pa-0>
                <v-layout row wrap>
                  <v-flex lg12>
                    <v-select outlined dense label="Loại hàng" class="input-group--focused" v-model="currentItem.ProductType" :items="filteredProductTypes" item-value="ID" item-text="Name"></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex lg12>
                    <h-currency-input label="Từ (m3)" v-model="currentItem.ValueMin" :decimal="1" class="input-group--focused"></h-currency-input>
                  </v-flex>
                  <v-flex lg12>
                    <h-currency-input label="Đến (m3)" v-model="currentItem.ValueMax" :decimal="1" class="input-group--focused"></h-currency-input>
                  </v-flex>
                  <v-flex lg12>
                    <h-currency-input label="Đơn giá" v-model="currentItem.Amount" :decimal="0" class="input-group--focused"></h-currency-input>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1 white--text" @click="closeDialog">Đóng</v-btn>
              <v-btn v-if="hasEditPermission" @click="editItem">Lưu lại</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
    </template>

    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import Filtering from "@/components/Filtering";
    import createPermissionMixin from "@/mixins/permissionMixin";
    import _ from "lodash";
    
    export default {
        mixins: [createPermissionMixin('setting')],
        props: ["currentUID", "showDialog"],
        components: {
            "hpo-filter": Filtering
        },
        data() {
            return {
                viewName: "feeVolume_list",
                dialogItem: false,
                headers: [
                    {
                        text: "ID",
                        value: "ID",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Loại hàng",
                        value: "ProductType",
                        filterable: true,
                        values: [],
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Từ (m3)",
                        value: "ValueMin",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Đến (m3)",
                        value: "ValueMax",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Đơn giá",
                        value: "Amount",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Ngày sửa đổi",
                        value: "ModifiedDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ],
                pagination: _.cloneDeep(configs.PAGINATION),
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
            loading() {
              this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleCreateButton: !this.hasEditPermission });
            },
            showDialog() {
                if(this.currentUID) {
                    this.dialogItem = this.showDialog;
                    this.$store.commit("feeVolume/setDetail", {data: {'ID': 0}});
                }
            },
            product_types() {
                let header_item = _.find(this.headers, { value: "ProductType" });
                if (header_item) {
                    header_item.values =
                    _.map(this.product_types, (item) => {
                        return {
                        value: item.ID,
                        name: item.Name,
                        };
                    }) || [];
                }
            }
        },
        computed: {
            ...mapState({
                items: state => state.feeVolume.all.data,
                total_rows: state => state.feeVolume.all.total,
                loading: state => state.feeVolume.loading,
                currentItem: state => state.feeVolume.selected,
                product_types: state => state.productType.all.data,
            }),
            filteredProductTypes() {
                if (!this.product_types) return [];
                return this.product_types.map(p => ({
                    ...p,
                    disabled: p.IsLocked == 1 || p.IsLocked == true
                }));
            },
        },
        methods: {
            filter_data: function () {
                var param = {
                    pagination: this.pagination,
                    filter: this.filterConditions,
                    quickFilter: this.quickFilterConditions
                };
                param.filter.push({
                    column: "UID",
                    value: this.currentUID ? this.currentUID : 0,
                    condition: "equal"
                });
                this.$store.dispatch("feeVolume/getList", param);
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            openItem: function (id) {
                if(!id) {
                    this.$store.commit("feeVolume/setDetail", {'ID': id});
                }
                else {
                    this.$store.dispatch("feeVolume/getDetail", id);
                }
                this.dialogItem = true;
            },
            deleteItem: function(id) {
                window.getApp.$emit('REQUEST_DELETE_DATA', id);
            },
            editItem() {
                this.$store.dispatch("feeVolume/setDetail", {
                    'data': {
                        ...this.currentItem,
                        UID: this.currentUID ? this.currentUID : 0,
                    },
                    'id': this.currentItem.ID
                });
                this.dialogItem = false;
                this.$emit('close');
            },
            closeDialog() {
                this.dialogItem = false;
                this.$emit('close');
            }
        },
        mounted() {
            this.$store.dispatch("productType/getList");
            this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
                this.$store.dispatch("feeVolume/removeDetail", id);
            });
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$off("CONFIRMED_REMOVE_DATA");
        }
    };
    </script>
